<script setup>
import ItemTexto from './ItemTexto';
import useRotas from '../../../../../Composables/useRotas';
import {ref} from "vue";

const route = useRotas();

const doulhetresConfig = ref(window.doulheTresConfig);

</script>

<template>
    <div class="flex row justify-start">
        <item-texto texto="Home" :href="route('home')" />
        <item-texto texto="Quero Vender" :href="route('institucional.queroVender')" />
        <item-texto texto="Blog" v-if="doulhetresConfig.link_blog && doulhetresConfig.link_blog != '#'" :href="route('institucional.links.blog')"/>
        <item-texto texto="FAQ" :href="route('institucional.ajuda')" />
        <item-texto texto="A Empresa" :href="route('institucional.quemSomos')" />
        <item-texto texto="Fale Conosco" :href="route('institucional.faleConosco')" />
        <item-texto texto="Denuncie Páginas Falsas" v-if="doulhetresConfig.link_denuncia && doulhetresConfig.link_denuncia != '#'" target="_blank" :href="route('institucional.links.denuncia')" />
    </div>
</template>
